import { render, staticRenderFns } from "./pendingShopEdit.vue?vue&type=template&id=4995fe7a&scoped=true"
import script from "./pendingShopEdit.vue?vue&type=script&lang=js"
export * from "./pendingShopEdit.vue?vue&type=script&lang=js"
import style0 from "./pendingShopEdit.vue?vue&type=style&index=0&id=4995fe7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4995fe7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4995fe7a')) {
      api.createRecord('4995fe7a', component.options)
    } else {
      api.reload('4995fe7a', component.options)
    }
    module.hot.accept("./pendingShopEdit.vue?vue&type=template&id=4995fe7a&scoped=true", function () {
      api.rerender('4995fe7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/shopManagement/pendingShop/pendingShopEdit.vue"
export default component.exports